import { css } from "@emotion/react";

export const styles = {
  wrapper: css`
    padding: var(--spacing-16);
    align-items: center;
    gap: var(--spacing-16);
    border-radius: var(--spacing-4);
  `,
  fill: css`
    display: flex;
    width: 100%;
    flex-shrink: 0;
  `,
  noFill: css`
    display: inline-flex;
  `,
  info: css`
    --icon-fill-color: var(--color-info);
    border: 1px solid var(--border-color-border-info, #9df);
    background: var(--background-color-background-info, #e5f6ff);
  `,
  warning: css`
    --icon-fill-color: var(--color-warning);
    border: 1px solid var(--border-color-border-warning, #fc9);
    background: var(--background-color-background-warning, #fff2e5);
  `,
  success: css`
    --icon-fill-color: var(--color-success);
    border: 1px solid var(--border-color-border-success, #adebad);
    background: var(--background-color-background-success, #ebfaeb);
  `,
  error: css`
    --icon-fill-color: var(--color-danger);
    border: 1px solid var(--border-color-border-danger, #f9a);
    background: var(--background-color-background-danger, #ffe5ea);
  `,
  center: css`
    justify-content: center;
  `,
  left: css`
    justify-content: flex-start;
  `,
  right: css`
    justify-content: flex-end;
  `,
  content: css`
    color: var(--color-primary, #000);
    font-size: var(--font-size-12);
  `,
  fillWithBorderModifications: css`
    display: flex;
    width: 100%;
    flex-shrink: 0;
    border-style: solid none;
    border-radius: 0px;
  `
};
